module.exports = __webpack_public_path__ + "img/icon9.725252de.png";